<div class="sps-status-wrap" [title]="statusTip" (click)="onTrySendClick()">
  <img src="../../../assets/images/SPS.ico" class="sps-icon" />
  <mat-icon class="status-badge" [ngClass]="statusClass">{{ statusIcon }}</mat-icon>
  <div class="try-send-popup" *ngIf="showPopup">{{ popupMessage }}</div>
</div>
